import React from "react";
import classNames from "classnames";

const GameButton = (props) => {
  const { link, logo, showNew, id } = props;

  return (
    <div id={id} className="switch-icon-wrapper">
      <a href={link} className={classNames("game-switch-icon")}>
        {logo}
      </a>
      {showNew && <div className="new-icon">NEW!</div>}
    </div>
  );
};

export default GameButton;
